import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pick, delay } from 'lodash';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import {
  Button, FormGroup, ControlLabel, HelpBlock,
} from 'react-bootstrap';
import Joi from 'joi';
import Toggle from 'react-bootstrap-toggle';
import { reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import { fetchFeedbackRequestSettings, updateFeedbackRequestSettings } from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import ProgressBar from '../../../../components/progress-bar';
import CRMInstanceName from '../../../../components/crm-instance-name';

const FORM_NAME = 'feedbackRequestSettings';


class FeedbackRequestSettingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onToggleEmailEditEnable = this.onToggleEmailEditEnable.bind(this);
    this.onToggleAddContactEnable = this.onToggleAddContactEnable.bind(this);
    this.onToggleCanMakeContactPrimaryEnable = this.onToggleCanMakeContactPrimaryEnable.bind(this);
    this.onToggleOpportunityStatusEnable = this.onToggleOpportunityStatusEnable.bind(this);
    this.onToggleCollectorSettingsEditable = this.onToggleCollectorSettingsEditable.bind(this);
    this.onToggleFeedbackRestriction = this.onToggleFeedbackRestriction.bind(this);
    this.onToggleSmartAccountId = this.onToggleSmartAccountId.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onToggleEmailEditEnable() {
    const { emailEditing } = this.props;
    this.props.change('email_editing', !emailEditing);
  }

  onToggleSmartAccountId() {
    const { smartAccountId } = this.props;
    this.props.change('smart_account_id', !smartAccountId);
  }
  
  onToggleAddContactEnable() {
    const { addContacts } = this.props;
    this.props.change('add_contacts', !addContacts);
  }

  onToggleCanMakeContactPrimaryEnable() {
    const { canMakeContactPrimary } = this.props;
    this.props.change('can_make_contact_primary', !canMakeContactPrimary);
  }

  onToggleOpportunityStatusEnable() {
    const { includeOpenOpportunities, handleSubmit } = this.props;
    this.props.change('include_open_opportunities', !includeOpenOpportunities);
    delay(() => {
      this.props.dispatch(handleSubmit(this.handleSubmit));
    }, 100);
  }

  onToggleCollectorSettingsEditable() {
    const { collectorSettingsEditable } = this.props;
    this.props.change('collector_settings_editable', !collectorSettingsEditable);
  }

  onToggleFeedbackRestriction() {
    const { feedbackRequestable } = this.props;
    this.props.change('feedback_requestable', !feedbackRequestable);
  }

  handleSubmit(rawParams) {
    const params = pick(rawParams, ['email_editing', 'add_contacts', 'can_make_contact_primary', 'include_open_opportunities', 'collector_settings_editable', 'feedback_requestable', 'smart_account_id']);
    params.email_editing = params.email_editing === true || params.email_editing === 'true';
    params.add_contacts = params.add_contacts === true || params.add_contacts === 'true';
    params.can_make_contact_primary = params.can_make_contact_primary === true || params.can_make_contact_primary === 'true';
    params.include_open_opportunities = params.include_open_opportunities === true || params.include_open_opportunities === 'true';
    params.collector_settings_editable = params.collector_settings_editable === true || params.collector_settings_editable === 'true';
    params.feedback_requestable = params.feedback_requestable === true || params.feedback_requestable === 'true';
    params.smart_account_id = params.smart_account_id === true || params.smart_account_id === 'true';

    const p = this.props.dispatch(updateFeedbackRequestSettings(this.props.organization._id, params));
    p.then(
      () => {
        const el = (<div>Settings updated</div>);
        this.context.addNotification(el, { type: 'success', autoClose: true });
      },
      (errors) => {
        const e = errors.data || errors;
        throw new SubmissionError(e);
      },
    );
    return p;
  }

  fetchData() {
    this.setState({ loading: true, loaded: false });
    this.props.dispatch(fetchFeedbackRequestSettings(this.props.organization._id))
      .then(
        (settings) => {
          if (this.mounted) {
            this.props.initialize(settings);
            this.setState({ loading: false, loaded: true });
          }
        },
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: false });
          }
        },
      );
  }

  renderContent() {
    const {
      handleSubmit, emailEditing, submitting,
      valid, addContacts, canMakeContactPrimary,
      showOpportunityStatus, includeOpenOpportunities,
      collectorSettingsEditable, canAddContacts,
      feedbackRequestable, smartAccountId,
    } = this.props;

    let body = null;
    if (showOpportunityStatus) {
      body = (
        <FormGroup>
          <ControlLabel>Include Open Opportunities:</ControlLabel>
          {' '}
          <Toggle
            onClick={this.onToggleOpportunityStatusEnable}
            on={<span>Enabled</span>}
            off={<span>Disabled</span>}
            onstyle="success"
            size="xs"
            offstyle="danger"
            active={includeOpenOpportunities}
            disabled={submitting}
          />
          <HelpBlock>
            {includeOpenOpportunities && <div>Open and closed opportunities will be displayed in the Feedback module and Request Feedback window.</div>}
            {!includeOpenOpportunities && <div>Only closed opportunities will be displayed.</div>}
          </HelpBlock>
        </FormGroup>
      );
    } else {
      body = (

        <div className="panel panel-default">
          <div className="panel-heading">
            Customize Modify Controls
          </div>
          <div className="panel-body">
            <FormGroup>
              <ControlLabel>Allow Email Editing:</ControlLabel>
              {' '}
              <Toggle
                onClick={this.onToggleEmailEditEnable}
                on={<span>Enabled</span>}
                off={<span>Disabled</span>}
                onstyle="success"
                size="xs"
                offstyle="danger"
                active={emailEditing}
                disabled={submitting}
              />
              <HelpBlock>
                {emailEditing && <div>Sales Reps will be able to edit the email content and email subject.</div>}
                {!emailEditing && <div>Sales Reps won&rsquo;t be able to edit the email content and email subject.</div>}
              </HelpBlock>
            </FormGroup>
            <hr />
            <FormGroup>
              <ControlLabel>Add Contacts to <CRMInstanceName />:</ControlLabel>
              {' '}
              <Toggle
                onClick={this.onToggleAddContactEnable}
                on={<span>Enabled</span>}
                off={<span>Disabled</span>}
                onstyle="success"
                size="xs"
                offstyle="danger"
                active={addContacts}
                disabled={submitting}
              />
              <HelpBlock>
                {addContacts && <div>Sales Reps will be able to add contacts to <CRMInstanceName />.</div>}
                {!addContacts && <div>Sales Reps won&rsquo;t be able to add contacts to <CRMInstanceName />.</div>}
                {!canAddContacts && <div className="alert alert-warning"><Fa name="exclamation-triangle" /> The integration user does not have the necessary permissions to add a contact to <CRMInstanceName />.</div>}
              </HelpBlock>
            </FormGroup>
            <hr />

            <FormGroup>
              <ControlLabel>Smart Account IDs:</ControlLabel>
              {' '}
              <Toggle
                onClick={this.onToggleSmartAccountId}
                on={<span>Enabled</span>}
                off={<span>Disabled</span>}
                onstyle="success"
                size="xs"
                offstyle="danger"
                active={smartAccountId}
                disabled={submitting}
              />
              <HelpBlock>
                {smartAccountId && <div>TruSales will use the opportunity&rsquo;s Account ID for contacts that do not have an associated Account ID.</div>}
                {!smartAccountId && <div>Contacts missing an Account ID will not be submitted for feedback requests.</div>}
              </HelpBlock>
            </FormGroup>
            <hr />

            {canAddContacts && addContacts &&
              <div>
                <FormGroup>
                  <ControlLabel>Allow Primary Opportunity Contact Setting:</ControlLabel>
                  {' '}
                  <Toggle
                    onClick={this.onToggleCanMakeContactPrimaryEnable}
                    on={<span>Enabled</span>}
                    off={<span>Disabled</span>}
                    onstyle="success"
                    size="xs"
                    offstyle="danger"
                    active={canMakeContactPrimary}
                    disabled={submitting}
                  />
                  <HelpBlock>
                    {canMakeContactPrimary && <div>When adding a contact, users can set the contact as the primary opportunity contact.</div>}
                    {!canMakeContactPrimary && <div>When adding a contact, users can not set the contact as the primary contact for the opportunity.</div>}
                  </HelpBlock>
                </FormGroup>
                <hr />
              </div>
            }
            <FormGroup>
              <ControlLabel>Allow manual override of collector setting:</ControlLabel>
              {' '}
              <Toggle
                onClick={this.onToggleCollectorSettingsEditable}
                on={<span>Enabled</span>}
                off={<span>Disabled</span>}
                onstyle="success"
                size="xs"
                offstyle="danger"
                active={collectorSettingsEditable}
                disabled={submitting}
              />
              <HelpBlock>
                {collectorSettingsEditable && <div>Users may override the survey collector's contact submission restriction settings.</div>}
                {!collectorSettingsEditable && <div>Users can not override the survey collector's contact submission restriction settings.</div>}
              </HelpBlock>
            </FormGroup>
            <hr />
            <FormGroup>
              <ControlLabel>Restrict Manual Feedback Requests</ControlLabel>
              {' '}
              <Toggle
                onClick={this.onToggleFeedbackRestriction}
                on={<span>Enabled</span>}
                off={<span>Disabled</span>}
                onstyle="success"
                size="xs"
                offstyle="danger"
                active={!feedbackRequestable}
                disabled={submitting}
              />
              <HelpBlock>
                {!feedbackRequestable && <div>Only opportunities that match the trigger conditions in the Automation settings will be eligible for feedback requests in TruSales.</div>}
                {feedbackRequestable && <div>All opportunities are eligible for feedback requests in the Feedback module in TruSales.</div>}
              </HelpBlock>
            </FormGroup>
          </div>
          <div className="panel-footer">
            <div className="text-right">
              <Button bsStyle="primary" disabled={!valid || submitting} type="submit">
                {!submitting && <span>Save</span>}
                {submitting && <span>Saving</span>}
              </Button>
            </div>
          </div>
        </div>
      );
    }
    

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        {body}
      </form>
    );
  }

  render() {
    const { loading, loaded } = this.state;
    const { showOpportunityStatus } = this.props;
    const isLoading = loading || !loaded;
    return (
      <div>
        {!showOpportunityStatus && <Helmet title="Feedback Request Modify Controls Settings | Organization Setup" />}
        {isLoading && <ProgressBar />}
        {!isLoading && this.renderContent()}
      </div>
    );
  }
}


const selector = formValueSelector(FORM_NAME); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state) {
  const organization = getUserCurrentOrganization(state);
  const emailEditing = selector(state, 'email_editing');
  const addContacts = selector(state, 'add_contacts');
  const canMakeContactPrimary = selector(state, 'can_make_contact_primary');
  const includeOpenOpportunities = selector(state, 'include_open_opportunities');
  const collectorSettingsEditable = selector(state, 'collector_settings_editable');
  const canAddContacts = selector(state, 'can_add_contacts');
  const feedbackRequestable = selector(state, 'feedback_requestable');
  const smartAccountId = selector(state, 'smart_account_id');
  return {
    organization,
    emailEditing,
    includeOpenOpportunities,
    addContacts,
    canMakeContactPrimary,
    canAddContacts,
    collectorSettingsEditable,
    feedbackRequestable,
    smartAccountId,
  };
}

FeedbackRequestSettingPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  change: PropTypes.func,
  valid: PropTypes.bool,
  emailEditing: PropTypes.bool,
  addContacts: PropTypes.bool,
  canMakeContactPrimary: PropTypes.bool,
  canAddContacts: PropTypes.bool,
  smartAccountId: PropTypes.bool,
  includeOpenOpportunities: PropTypes.bool,
  showOpportunityStatus: PropTypes.bool,
  collectorSettingsEditable: PropTypes.bool,
  feedbackRequestable: PropTypes.bool,
};
FeedbackRequestSettingPage.defaultProps = {
  submitting: false,
  handleSubmit: () => {},
  initialize: () => {},
  change: () => {},
  valid: false,
  emailEditing: false,
  addContacts: false,
  smartAccountId: false,
  includeOpenOpportunities: false,
  showOpportunityStatus: false,
  collectorSettingsEditable: false,
  feedbackRequestable: false,
};
FeedbackRequestSettingPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


const validate = (data) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   email_editing: {
  //     presence: true,
  //     inclusion: {
  //       within: [true, false],
  //       message: '^Invalid value of %{value}',
  //     },
  //   },
  // };

  const schema = Joi.object({
    email_editing: Joi.boolean().required().messages({
      'boolean.base': 'Email editing must be true or false',
      'any.required': 'Email editing is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const FeedbackRequestSettingForm = reduxForm({
  form: FORM_NAME,
  validate,
})(FeedbackRequestSettingPage);

export default connect(mapStateToProps)(FeedbackRequestSettingForm);
